import { AVATAR_COLORS } from './consts'
import type { AvatarColor } from './types'

/**
 * Deterministically maps a name to a palette color via a simple string hash, so the same
 * name always renders with the same color across the app.
 */
export const getColorForName = (name: string): AvatarColor => {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}
